/**
 * CheTuo Web — Payment API functions.
 * Reuses /api/shop-mobile/payments and /api/shop-mobile/orders/:orderId/payment.
 */

import { apiClient, shopMobilePath } from './client';

export interface PaymentInfo {
  id: string;
  orderId: string;
  method: string;
  amount: string;
  status: string;
  confirmedBy: string;
  confirmedAt: string;
}

export function getPaymentByOrder(orderId: string): Promise<PaymentInfo | null> {
  return apiClient.get<PaymentInfo | null>(
    shopMobilePath(`/orders/${orderId}/payment`),
  );
}

export function confirmPayment(input: {
  orderId: string;
  method: string;
  amount: string;
  idempotencyKey: string;
}): Promise<PaymentInfo> {
  return apiClient.post<PaymentInfo>(
    shopMobilePath('/payments'),
    input,
  );
}
